import { render, staticRenderFns } from "./addCategrized.vue?vue&type=template&id=2f6b33be&scoped=true"
import script from "./addCategrized.vue?vue&type=script&lang=js"
export * from "./addCategrized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6b33be",
  null
  
)

export default component.exports